import $ from 'jquery';
import _ from 'underscore';
import * as registry from '../../../home24/core/registry';

export default function WishlistEvents() {
  this.selectors = {
    articleParent: '.js-wishlist-article__wrap',
    articleName: '.js-tracking-wishlist-product-click'
  };

  this.bindEvents();
}

/**
 * Checks whether the given event has been executed
 * holding appropriate keyboard button in order to open a new tab
 *
 * event.metaKey = ⌘ (command in apple)
 * event.button == 1 = middle mouse button
 *
 * @param {MouseEvent} event
 */
function isClickedForNewTab(event) {
  return (
    event.ctrlKey ||
    event.shiftKey ||
    event.metaKey ||
    (event.button && event.button == 1)
  );
}

WishlistEvents.prototype = {
  bindEvents: function() {
    $(this.selectors.articleName).on(
      'click.wishlistEvents',
      _.bind(this.onArticleClicked, this)
    );
  },

  onAddToWishlist: function(event) {
    event.preventDefault();

    var $form = $(event.currentTarget);

    window.dataLayer.push({
      productSku: $form.find('[name="sku[]"]').val(),
      productPrice: '',
      productBrand: '',
      productCategory: '',
      event: 'addToWL',
      eventCallback: _.bind(this.submitTheForm, this, $form)
    });
  },

  onRemoveFromWishlist: function(event) {
    event.preventDefault();

    var $form = $(event.currentTarget);

    window.dataLayer.push({
      productSku: $form.find('[name=sku]').val(),
      productPrice: '',
      event: 'removeFromWL',
      eventCallback: _.bind(this.submitTheForm, this, $form)
    });
  },

  onArticleAddedToCart: function(event) {
    event.preventDefault();

    var trackingData;
    var $form;

    $form = $(event.currentTarget);

    trackingData = this.getTrackingData($form);

    trackingData.dimension65 = 'wishlist';

    window.dataLayer.push({
      event: 'addToCart',
      ecommerce: {
        add: {
          // needs to be an array
          products: [trackingData]
        },
        cartValue: '',
        currencyCode: registry.get('currencyCode'),
        pageType: 'wishlist'
      },
      eventCallback: _.bind(this.submitTheForm, this, $form)
    });
  },

  // another implementation of productClick tracking event,
  // to avoid http/https localStorage issues
  onArticleClicked: function(event) {
    var clickedForNewTab = isClickedForNewTab(event);

    if (!clickedForNewTab) {
      event.preventDefault();
    }

    var $clickedElement = $(event.currentTarget);
    var trackingData = this.getTrackingData($clickedElement);
    var dataLayerEvent = {
      event: 'productClick',
      ecommerce: {
        click: {
          actionField: {
            action: 'click',
            list: 'Wishlist'
          },
          products: [trackingData]
        }
      }
    };

    if (!clickedForNewTab) {
      dataLayerEvent.eventCallback = _.bind(
        this.redirect,
        this,
        $clickedElement.attr('href')
      );
    }

    window.dataLayer.push(dataLayerEvent);
  },

  getTrackingData: function($clickedEl) {
    var sku = $clickedEl.parents(this.selectors.articleParent).attr('data-sku');
    var data = {};
    var dataSource = registry.get('wishlist.trackingData');

    // on wishlist page read from Registry
    if (dataSource && dataSource[sku]) {
      data = dataSource[sku];
    }

    return data;
  },

  redirect: function(url) {
    document.location = url;
  },

  destroy: function() {
    $(this.selectors.articleName).off('click.wishlistEvents');
  }
};



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/tracking/wishlist/wishlistEvents.js
 **/